<template>
  <PartnerSelector v-model="localValue" @partner="impersonate"/>
</template>

<script lang="ts">
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import User from "@/entity/User";
import {api} from "@/services/Api";
import {auth} from "@/services/Auth";
import UserSelector from "@/components/UserSelector.vue";
import PartnerSelector from "@/components/PartnerSelector.vue";

@Component({
  components: {PartnerSelector, UserSelector}
})
export default class PartnerImpersonator extends Vue {

  @Prop({default: ''}) value?: string;

  localValue?: string = ''


  @Watch('value')
  computed() {
    this.localValue = this.value
  }

  async impersonate(user: any) {
    const res = await api.get(api.auth, 'auth/partner/impersonate/' + user.id)
    if (res && res.data && res.data.token && res.data.refreshToken) {
      await auth.impersonate(res.data)
      localStorage.setItem('userType', 'partner')
      window.location.reload()
    }
  }
}
</script>


<style scoped>

</style>
